/** Pipeline agents — must stay in sync with backend PIPELINE_BLUEPRINT titles. */

export const PIPELINE_AGENT_ORDER = [
  'planner',
  'designer',
  'backend',
  'frontend',
  'integration_secrets',
  'tester',
  'fixer',
  'deployment',
  'architect',
  'architect_summary',
  'ui_targets',
  'uiux',
  'devops',
  'qa_pass_1',
  'revision',
  'merge',
  'qa_pass_2',
  'deployment_validation',
  'final_display',
];

export const PIPELINE_AGENT_TITLES = {
  planner: 'Planner Agent',
  designer: 'Designer Agent',
  backend: 'Backend Agent',
  frontend: 'Frontend Agent',
  integration_secrets: 'Integration/Secrets Agent',
  tester: 'Tester Agent',
  fixer: 'Fixer Agent',
  deployment: 'Deployment Checker',
  architect: 'Architect Agent',
  architect_summary: 'Architect Summary Extractor',
  ui_targets: 'UI Targets Extractor',
  uiux: 'UI/UX Design Agent',
  devops: 'DevOps Agent',
  qa_pass_1: 'QA Agent Pass 1',
  revision: 'Revision Agent',
  merge: 'Merge Agent',
  qa_pass_2: 'QA Agent Pass 2',
  deployment_validation: 'Deployment Validator',
  final_display: 'Final Compiler',
};

export function normalizePipelinePhases(phases = [], { showWhenIdle = false } = {}) {
  if (!Array.isArray(phases) || !phases.length) {
    if (!showWhenIdle) return [];
    return PIPELINE_AGENT_ORDER.map((key) => ({
      key,
      title: PIPELINE_AGENT_TITLES[key] || key,
      status: 'pending',
    }));
  }
  const mappedPhases = phases.map((phase) => {
    if (!phase) return phase;
    const key = phase.key || phase.name;
    return {
      ...phase,
      key,
      title: phase.title || PIPELINE_AGENT_TITLES[key] || phase.name,
      status: phase.status === 'passed' ? 'done' : phase.status === 'failed' ? 'error' : phase.status,
    };
  });
  const hasActivity = mappedPhases.some((p) => p?.status && p.status !== 'pending');
  if (!hasActivity && !showWhenIdle) return [];
  const byKey = Object.fromEntries(mappedPhases.filter(Boolean).map((p) => [p.key, p]));
  return PIPELINE_AGENT_ORDER.map((key) => {
    const phase = byKey[key];
    return {
      key,
      title: phase?.title || PIPELINE_AGENT_TITLES[key] || key,
      description: phase?.description || '',
      status: phase?.status || 'pending',
    };
  });
}

export function activePipelineAgent(phases = []) {
  const normalized = normalizePipelinePhases(phases, { showWhenIdle: true });
  const running = normalized.find((p) => p.status === 'running');
  if (running) return running;
  const lastDone = [...normalized].reverse().find((p) => p.status === 'done');
  return running || lastDone || null;
}
